module.exports = __webpack_public_path__ + "img/组 4.cc346e3e.webp";